import { IconWithLogoBackground } from "@package/subframe/components/IconWithLogoBackground";
import { FeatherBuilding } from "@subframe/core";
import { createFileRoute } from "@tanstack/react-router";

import { RoomsTable } from "@/components/RoomsTable";
import { Spinner } from "@/components/ui/spinner";
import { useNursery } from "@/contexts/NurseryContext";

export const Route = createFileRoute("/_authenticated/rooms")({
  component: RoomsPage,
});

function RoomsPage() {
  const { selectedNurseryId, selectedNursery, isLoading } = useNursery();

  if (isLoading) {
    return (
      <div className="flex w-full items-center justify-center py-12">
        <Spinner className="h-8 w-8 text-primary" />
      </div>
    );
  }

  if (!selectedNurseryId) {
    return (
      <div className="flex w-full flex-col items-center justify-center py-12 gap-4">
        <IconWithLogoBackground
          variant="neutral"
          size="x-large"
          icon={<FeatherBuilding />}
        />
        <span className="text-heading-3 font-heading-3 text-default-font">
          No nursery selected
        </span>
        <span className="text-body font-body text-subtext-color">
          Select a nursery from the sidebar to manage its rooms.
        </span>
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col items-start gap-6 animate-fade-in">
      <div className="flex w-full flex-col items-start gap-1">
        <span className="text-heading-2 font-heading-2 text-default-font">
          Rooms — {selectedNursery?.name}
        </span>
        <span className="text-body font-body text-subtext-color">
          Manage rooms for your nursery
        </span>
      </div>
      <RoomsTable nurseryId={selectedNurseryId} />
    </div>
  );
}
